import React from "react"
import { Field, useField, useFormikContext } from "formik"

// import InputBullet from "./Inputs/InputBullet"
// import InputComputed from "./Inputs/InputComputed"
// import InputCheckbox from "./Inputs/InputCheckbox"
import InputCount from "./Inputs/InputCount"
import InputDropzone from "./Inputs/InputDropzone"
import InputImage from "./Inputs/InputImage"
import InputRadio from "./Inputs/InputRadio"
import InputSelect from "./Inputs/InputSelect"
import InputSwitch from "./Inputs/InputSwitch"
import { useEffect } from "react"

import pick from "lodash/pick"

function InputComputed({
  value,
  listen,
  mapComputedToChange,
  onChange,
  render,
}) {
  const listened = listen.map(useField).map((_) => _[0].value)
  // const [computed] = useField(field)

  // useEffect(() => {
  //   const changedValue = mapComputedToChange(listened?.value)
  //   // computed.onChange(changedValue)
  //   // mapComputedToChange && mapComputedToChange(computed.value, onChange)
  // }, [listened.value])

  useEffect(() => {
    const changedValue = mapComputedToChange && mapComputedToChange(listened)
    onChange && onChange(changedValue)
  }, [...listened])

  return render({ value })
}

const customComponents = {
  // checkbox: props => <InputCheckbox {...props} />,
  // dropzone: props => <InputDropzone {...props} />,
  // file: props => <InputFileUpload {...props} />,
  // gallery: props => <InputImageGallery {...props} />,
  // bullet: (props) => (
  //   <InputBullet
  //     values={props.value}
  //     onChange={(value) => props.onChange(value)}
  //   />
  // ),

  computed: (props) => <InputComputed {...props} />,
  checkbox: (props) => <Field type="checkbox" {...props} />,
  count: (props) => <InputCount {...props} />,
  dropzone: (props) => <InputDropzone {...props} />,
  image: (props) => <InputImage {...props} />,
  radio: (props) => <InputRadio {...props} />,
  select: (props) => <InputSelect {...props} />,
  switch: (props) => <InputSwitch {...props} />,
  textarea: (props) => (
    <textarea
      {...props}
      onChange={(e) => props.onChange(e.target.value)}
      className="form-textarea mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
      rows="6"
    />
  ),
}

const Input = ({ error, ...props }) => {
  const classNames = `mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ${
    error && "border-red-500"
  }`

  if (props.type === "select")
    return (
      <select className={`form-select ${classNames}`} {...props}>
        {props.options.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    )

  if (props.type === "price")
    return (
      <div className="mt-1 relative rounded-md shadow-sm">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <span className="text-gray-500 sm:text-sm">$</span>
        </div>

        <input
          name="price"
          id="price"
          // className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
          placeholder="0.00"
          {...props}
          type="number"
          className={`form-input ${classNames} pl-7`}
        />
        {/* <div className="absolute inset-y-0 right-0 flex items-center">
            <label for="currency" className="sr-only">
              Currency
            </label>
            <select
              id="currency"
              name="currency"
              className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
            >
              <option>USD</option>
              <option>CAD</option>
              <option>EUR</option>
            </select>
          </div> */}
      </div>
    )

  if (props.type === "date") {
    // const date = new Date(props.value).toISOString().substring(0, 10),
    // const value = props?.value ? props?.value?.split("T")[0] : ""
    // const value = props?.value
    //   ? new Date(props.value).toISOString().substring(0, 10)
    //   : ""
    const value = props.value
    return (
      <input
        {...props}
        className={`form-input ${classNames}`}
        // type={props.type ? props.type : "text"}
        // value={value}
      />
    )
  }

  if (props.type === "quantity") {
    // const date = new Date(props.value).toISOString().substring(0, 10),
    const value = props?.value
    const isInfinity = value === Infinity

    return (
      <input
        {...props}
        className={`form-input ${classNames}`}
        type={isInfinity ? "text" : "number"}
        // value={isInfinity ? "∞" : value}
        value={value}
      />
    )
  }

  // ∞
  return (
    <input
      {...props}
      className={`form-input ${classNames}`}
      type={props.type ? props.type : "text"}
    />
  )
}

const Fieldset = ({ label, component = "input", onTouched, ...props }) => {
  const [field, meta, helpers] = useField(props)
  const { name, maxlength } = props

  useEffect(() => {
    onTouched && onTouched(meta.touched)
  }, [meta.touched])

  return (
    <fieldset className="block w-full">
      <label className="block">
        <div className="flex justify-between">
          {label && (
            <span className="block text-sm font-medium text-gray-700">
              {label}
            </span>
          )}

          {maxlength && (
            <span className="block text-xs font-medium text-gray-700">
              {field.value?.length}/{maxlength}
            </span>
          )}
        </div>
        {customComponents[component] ? (
          customComponents[component]({
            ...field,
            ...props,
            ...meta,
            name,

            onChange: helpers.setValue,
          })
        ) : (
          <>
            <Input {...field} {...props} error={meta.error} />
          </>
        )}
      </label>

      {meta.error && (
        <div className="text-sm error bg-red-200 text-red-800 p-2 mt-2">
          {meta.error}
        </div>
      )}

      {/* <ErrorMessage name={name}>
        {(message) => (
          <div className="text-sm error bg-red-200 text-red-800 p-2 mt-2">
            {message}
          </div>
        )}
      </ErrorMessage> */}
    </fieldset>
  )
}

export default Fieldset
